<template>
  <svg
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4774 9.43994C9.04416 9.43994 6.73426 11.1674 7.0248 13.5516C7.04737 13.7368 7.07431 13.9311 7.10561 14.1379C7.19875 14.753 7.74229 15.1999 8.37253 15.1999H9.09296L9.61856 18.4203C9.76714 19.3306 10.5633 19.9999 11.4976 19.9999C12.432 19.9999 13.2281 19.3306 13.3767 18.4203L13.9023 15.1999H14.632C15.2581 15.1999 15.8001 14.759 15.8956 14.1484C15.9261 13.9532 15.9524 13.769 15.9743 13.5923C16.2723 11.1911 13.9287 9.43994 11.4774 9.43994Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M11.4998 9.12C12.9324 9.12 14.0938 7.97385 14.0938 6.56C14.0938 5.14615 12.9324 4 11.4998 4C10.0671 4 8.90576 5.14615 8.90576 6.56C8.90576 7.97385 10.0671 9.12 11.4998 9.12Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
